export default {
  id: 'id',
  name: 'name',
  isAddedByTourOperator: 'isAddedByTourOperator',
  isSpecialSSR: 'isSpecialSSR',
  note: 'note',
  ssrNumber: 'ssrNumber',
  attributes: 'attributes',
  toDelete: 'toDelete',
}
